
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export const EnrollmentBasicInfoComponent = ({
    parentTopicsList, handleInnerFormChange, FileType, selectedLmsEnrollment, Moduleslist, EntityType, Chapterslist
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Entity Type Name"
                            labelField="EntityTypeName"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'EntityTypeName'
                                );
                            }}
                            type="text"
                            value={selectedLmsEnrollment?.EntityTypeName}
                        />




                        <InputContainer
                            label="Status"
                            labelField="Status"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Status'
                                );
                            }}
                            type="text"
                            value={selectedLmsEnrollment?.Status}
                        />

                        <InputContainer

                            label="Active"
                            name="IsActive"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event, 'IsActive');
                            }}
                            type="checkbox"
                            value={selectedLmsEnrollment?.IsActive}
                        />

                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>

    )
}

export default EnrollmentBasicInfoComponent;